/** PowerTRX primary-cause picker. The options are PowerTRX's own cause tree
 *  (GET /oms/causes), indented by depth; any level may be picked, as in
 *  PowerTRX. The value is the cause NAME, which is what the PowerTRX export
 *  writes to its "cause name" column. */
import { useCauses } from '../../hooks/useOms.ts'

// Non-breaking spaces: a <select> collapses ordinary leading whitespace.
const INDENT = '   '

export function CausePicker({
  value,
  onChange,
  disabled,
  id,
  className,
}: {
  value: string | null
  onChange: (cause: string | null) => void
  disabled?: boolean
  id?: string
  className?: string
}) {
  const { data: causes, isLoading, isError } = useCauses()
  const options = (Array.isArray(causes) ? causes : [])
    // "Unknown" is both a group and its only leaf: show it once.
    .filter(c => c.path[c.path.length - 1] !== c.name)

  return (
    <select
      id={id}
      value={value ?? ''}
      onChange={e => onChange(e.target.value || null)}
      disabled={disabled || isLoading || isError}
      className={className ?? 'mt-1 w-full text-sm border border-gray-300 rounded-md px-2 py-1.5'}
      aria-label="Cause"
    >
      <option value="">
        {isLoading ? 'Loading causes…' : isError ? 'Could not load causes' : '-- choose a cause --'}
      </option>
      {options.map(c => (
        <option key={c.name} value={c.name} title={[...c.path, c.name].join(' › ')}>
          {INDENT.repeat(c.depth)}
          {c.name}
        </option>
      ))}
    </select>
  )
}
